import { css } from 'lit';
import { LitElement, PropertyValues, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import resetScss from '../css/lib/reset.scss';
import sharedScss from '../css/shared.scss';
import utilityClassesCss from '../css/utilityClasses.css';
import './app-bubble';

@customElement('app-icon')
export default class AppIcon extends LitElement {
	@property({ type: String, reflect: true }) public href = '';

	@property({ type: Number }) public width = 16;

	@property({ type: Number }) public height = 16;

	static override get styles() {
		return [
			resetScss,
			sharedScss,
			utilityClassesCss,
			css`
				:host,
				svg {
					width: var(--width, 16px);
					height: var(--height, 16px);
				}
			`,
		];
	}

	override render() {
		return html`<span class="flex align-items-center justify-content-center"
				><svg role="presentation" part="svg">
					<use href="${this.href}"></use>
				</svg> </span
			><slot></slot>`;
	}

	override updated(changed: PropertyValues<this>) {
		if (changed.has('width') || changed.has('height')) {
			this.style.setProperty('--width', `${this.width}px`);
			this.style.setProperty('--height', `${this.height}px`);
		}
	}
}
